import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Collection() {
  const categories = [{
    title: 'Bone Straight',
    tag: 'Best Seller',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/k8sZrn1TVtcLpRviLVJKY7/bone-straight-vietnamese-hair-premium-quality.png',
    description: 'Silky smooth perfection with natural shine and movement. Our most requested texture for its versatility and elegance.'
  }, {
    title: 'Body Wavy',
    tag: 'Popular',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/ggPzLkoXsAECAmXsCcUaue/body-wavy-vietnamese-hair-premiuem-quality.png',
    description: 'Soft, natural waves that add volume and dimension. Perfect for effortless, glamorous styling.'
  }, {
    title: 'Deep Curly',
    tag: 'Trending',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/ooKzFS2iirvcx3SFXkKXZz/deep-way-vietnamese-hair-vietnamese-hair-high-quality.png',
    description: 'Rich, defined curls with exceptional bounce and fullness. A statement texture for bold, beautiful looks.'
  }, {
    title: 'Burmese Curly',
    tag: 'Classic',
    imageUrl: 'https://cdn.magicpatterns.com/uploads/6rPEsP6PhehxMA1kQp5wGi/burmesecurly-vietmamese-hair.png',
    description: 'Timeless spiral curls with natural texture and lasting pattern. Elegant and endlessly versatile.'
  }];
  const whatsappUrl = 'https://api.whatsapp.com/send/?phone=84869812254&text&type=phone_number&app_absent=0';
  return <section id="collection" className="pt-24 pb-12 bg-white" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-21">
            <h2 className="text-4xl md:text-5xl font-bold text-[#4B280B] mb-6" data-id="element-22">
              Our Premium Collections
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-23">
              Explore our curated range of hair textures. All collections are
              made from 100% human hair with carefully aligned cuticles,
              ensuring exceptional softness, durability, and tangle-free
              performance.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-24">
          {categories.map((category, index) => <motion.div key={category.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group cursor-pointer" data-id="element-25">
              <div className="relative h-96 rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500" data-id="element-26">
                <img src={category.imageUrl} alt={category.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-27" />
                {/* Dark gradient overlay for text readability */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-28" />

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white" data-id="element-29">
                  <p className="text-xs font-bold text-[#D4A574] mb-2 uppercase tracking-widest" data-id="element-30">
                    {category.tag}
                  </p>
                  <h3 className="text-2xl font-bold mb-3 tracking-tight" data-id="element-31">
                    {category.title}
                  </h3>
                  <p className="text-sm text-white/90 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-y-2 group-hover:translate-y-0" data-id="element-32">
                    {category.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-33">
          <Button size="lg" className="bg-[#7E3007] hover:bg-[#4B280B] text-white px-8 py-6 text-lg shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1" onClick={() => window.open(whatsappUrl, '_blank')} data-id="element-34">
            Request Full Catalog
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-35">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-36" />
            </svg>
          </Button>
        </div>
      </div>
    </section>;
}